const constants = {
  sign_up_url: process.env.REACT_APP_SIGN_UP_URL,
  handlers_base_url: process.env.REACT_APP_HANDLERS_BASE_URL,
  developer_portal_url: process.env.REACT_APP_DEVELOPER_PORTAL_URL,
  handlers_apikey: process.env.REACT_APP_HANDLERS_APIKEY,
  panelWidth: 400,
}

export default constants;
